/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Currency = {
    KZT: 'KZT',
    USD: 'USD',
    RUB: 'RUB',
    KGS: 'KGS',
    UZS: 'UZS',
    TJS: 'TJS'
} as const;
export type Currency = typeof Currency[keyof typeof Currency];

